export default {
    name: 'Imię',
    tel: 'telefon',
    save: 'zapisać',
    confirm: 'potwierdzać',
    cancel: 'Anulować',
    delete: 'usunąć',
    complete: 'Skończyć',
    loading: 'Ładowanie...',
    telEmpty: 'Proszę podać numer telefonu',
    nameEmpty: 'proszę wpisać swoje imię',
    nameInvalid: 'Proszę wpisać prawidłowe imię',
    confirmDelete: 'Czy na pewno chcesz usunąć',
    telInvalid: 'Podaj poprawny numer telefonu',
    vanCalendar: {
        end: 'koniec',
        start: 'Początek',
        title: 'tytuł',
        confirm: 'potwierdzać',
        startEnd: 'początek Koniec',
        weekdays: ['Dzień', 'Jeden', 'Dwa', 'Trzy', 'Cztery', 'Pięć', 'Sześć'],
    },
    vanCascader: {
        select: 'proszę wybrać',
    },
    vanContactCard: {
        addText: 'Dodaj kontakty',
    },
    vanContactList: {
        addText: 'nowy kontakt',
    },
    vanPagination: {
        prev: 'Poprzednia strona',
        next: 'Następna strona',
    },
    vanPullRefresh: {
        pulling: 'Pociągnij w dół, aby odświeżyć...',
        loosing: 'zwolnij odświeżenie...',
    },
    vanSubmitBar: {
        label: 'wszystko:',
    },
    vanCoupon: {
        unlimited: 'brak ograniczeń użytkowania',
    },
    vanCouponCell: {
        title: 'kupon',
        tips: 'Niedostępne',
    },
    vanCouponList: {
        empty: 'brak kuponu',
        exchange: 'Wymieniać się',
        close: 'brak kuponu',
        enable: 'nadający się do użytku',
        disabled: 'Niedostępne',
        placeholder: 'Wprowadź kod promocyjny',
    },
    vanAddressEdit: {
        area: 'powierzchnia',
        postal: 'kod pocztowy',
        areaEmpty: 'Wybierz region',
        addressEmpty: 'Proszę podać dokładny adres',
        postalEmpty: 'Nieprawidłowy format kodu pocztowego',
        defaultAddress: 'Ustaw jako domyślny adres wysyłki',
        telPlaceholder: 'Numer telefonu komórkowego odbiorcy',
        namePlaceholder: 'Nazwa odbiorcy',
        areaPlaceholder: 'Wybierz prowincję/miasto/region',
    },
    vanAddressEditDetail: {
        label: 'adres',
        placeholder: 'Numer ulicy, numer pokoju na piętrze itp.',
    },
    vanAddressList: {
        add: 'Dodaj adres',
    },
};
